/**
 * WILD scroll motion. Blocks fade up as they enter the viewport and items in rows stagger.
 * Numbers marked with data-wild-count count up. Styles live in wild.css.
 *
 * Targets:
 *   - Horizon sections: direct blocks of .section-content-wrapper, and the items of horizontal rows.
 *   - WILD components: [data-wild-reveal] elements, and the children of [data-wild-stagger].
 */
import { motionEnabled, countUp } from '@wild/utils';

const TARGETS = [
  'main .section-content-wrapper > :not(:has(.layout-panel-flex--row))',
  'main .section-content-wrapper .layout-panel-flex--row > *',
  '[data-wild-reveal]',
  '[data-wild-stagger] > *',
].join(', ');

const STAGGER_PARENTS = '.layout-panel-flex--row, [data-wild-stagger]';
const STAGGER_STEP = 0.12;

const reveal = (element) => {
  element.classList.add('is-in');
  element.querySelectorAll('[data-wild-count]').forEach((counter) => {
    const match = /^(\d+)(.*)$/.exec(counter.dataset.wildCount || counter.textContent.trim());
    if (match) countUp(counter, Number(match[1]), match[2]);
  });
};

const init = () => {
  if (!motionEnabled()) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  document.querySelectorAll(TARGETS).forEach((element) => {
    const parent = element.parentElement;
    if (parent?.matches(STAGGER_PARENTS)) {
      const index = Array.prototype.indexOf.call(parent.children, element);
      element.style.setProperty('--wild-delay', `${index * STAGGER_STEP}s`);
    }
    observer.observe(element);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
